const isDevOrStaging =
  process.env.NODE_ENV === "development" ||
  process.env.NODE_ENV === "staging";

export const devLog = (...args: unknown[]): void => {
  if (!isDevOrStaging) return;
  // eslint-disable-next-line no-console
  console.log(...args);
};

export const devError = (...args: unknown[]): void => {
  if (!isDevOrStaging) return;
  // eslint-disable-next-line no-console
  console.error(...args);
};
